import { call, put, takeLatest, select } from 'redux-saga/effects';
import VIDEO_TYPES from './types';
import { sagaWrapper } from 'src/helpers';
import sectionActions from '../Sections/actions';
import notificationActions from '../Notifications/actions';
import Service from 'src/service';
import { type RootState } from 'src/store';
import { IResponse, IVideo, type ISection, type IUser } from 'src/models';

const Video = new Service('videos');

function* create({ payload }: any) {
	const video = payload.video;
	const response: IResponse<IVideo> = yield call(Video.create, video);
	yield put(notificationActions.add('success', 'Video subido'));
	yield put(sectionActions.getOne(response.data?.sectionId!));
	yield put(sectionActions.set('videoDialogOpen', false));
}

function* update({ payload }: any) {
	const video = payload.video;
	yield call(Video.update, video);
	yield put(notificationActions.add('success', 'Video actualizado'));
	yield put(sectionActions.getOne(video.sectionId));
	yield put(sectionActions.set('videoDialogOpen', false));
}

function* remove({ payload }: any) {
	yield call(Video.delete, payload.id);
	yield put(notificationActions.add('success', 'Video eliminado'));

	const section: ISection = yield select(
		(state: RootState) => state.sections.section,
	);
	yield put(sectionActions.getOne(section.id || 0));
}

function* markSeen({ payload }: any) {
	const user: IUser = yield select((state: RootState) => state.auth.data);
	yield call(Video.createPath, 'seen', {
		userId: user.id,
		videoId: payload.videoId,
	});
}

function* updateOrder({ payload }: any) {
	yield call(Video.updatePath, `order`, payload.videos);
	yield put(notificationActions.add('success', 'Orden actualizado'));
	yield put(sectionActions.getOne(payload.sectionId));
}

function* handleActivation({ payload }: any) {
	const { id, value } = payload;
	yield call(Video.updatePath, `${id}/handleActivation?value=${value}`, {});
	const section: ISection = yield select(
		(state: RootState) => state.sections.section,
	);
	yield put(
		notificationActions.add(
			'success',
			`Video ${value ? 'activado' : 'desactivado'}`,
		),
	);
	yield put(sectionActions.getOne(section.id || 0));
}

export default function* index() {
	yield takeLatest(VIDEO_TYPES.CREATE, sagaWrapper(create, sectionActions.set('isUploadingVideo', false)));
	yield takeLatest(VIDEO_TYPES.UPDATE, sagaWrapper(update, sectionActions.set('isUploadingVideo', false)));
	yield takeLatest(VIDEO_TYPES.REMOVE, sagaWrapper(remove));
	yield takeLatest(VIDEO_TYPES.MARK_SEEN, sagaWrapper(markSeen));
	yield takeLatest(VIDEO_TYPES.UPDATE_ORDER, sagaWrapper(updateOrder));
	yield takeLatest(
		VIDEO_TYPES.HANDLE_ACTIVATION,
		sagaWrapper(handleActivation),
	);
}
